export class MonitorKey {
    MonitorHandler: string;
    MachinePhysicalAddress: string;

    constructor(handler: string, macPA: string) {
        this.MachinePhysicalAddress = macPA;
        this.MonitorHandler = handler;
    }
}
